<script setup>
// core
import {ref, getCurrentInstance} from "vue";
import {useStore} from "vuex";

// components
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

// assets
import tiktokSvg from "@/assets/icons/messengers/tiktok_btn.svg";

const store = useStore()
const {proxy} = getCurrentInstance()

const isInitiateLoading = ref(false)

const onClick = async () => {
    isInitiateLoading.value = true

    try {
        const url = await store.dispatch('tiktok/initiateActivation', {
            moshaToast: proxy.$moshaToast,
        })

        // the tiktok authorization page opens in place, it redirects back here
        // with the activation result in the query
        window.location.assign(url)
    } catch (e) {
        isInitiateLoading.value = false
    }
}
</script>

<template>
    <div class="activation">
        <HeaderMain>{{ $t("page.tiktok_activation.mainheader") }}</HeaderMain>

        <div class="activation__block">
            <div class="activation__logo">
                <img :src="tiktokSvg" alt="Tiktok"/>
            </div>
            <div class="activation__start">
                <p class="activation__text">
                    {{ $t("page.tiktok_activation.header") }}
                </p>

                <p class="activation__beta">
                    {{ $t("page.tiktok_activation.beta") }}
                </p>

                <ul>
                    <li>{{ $t("page.tiktok_activation.text1") }}</li>
                    <li>{{ $t("page.tiktok_activation.text2") }}</li>
                    <li>{{ $t("page.tiktok_activation.text3") }}</li>
                </ul>
                <div class="activation__notice">
                    <i class="bi bi-exclamation-circle"></i>
                    <p>
                        <b>{{ $t("page.tiktok_activation.important_title") }}</b>
                        {{ $t("page.tiktok_activation.important") }}
                    </p>
                </div>

                <ButtonLoading class="ec_button" :loading="isInitiateLoading" @click="onClick">
                    {{ $t("page.tiktok_activation.button") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.activation {
    &__start {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    &__block {
        margin-top: 30px;
        padding: 23px 48px;

        width: 100%;
        border-radius: 11px;
        background: var(--block-color);
        display: flex;
        align-items: center;
        gap: 52px;

        box-sizing: border-box;
    }

    &__logo {
        flex: 0 0 auto;
        width: 140px;
        height: 140px;
        border-radius: 24px;
        background: var(--tiktok-color);
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            width: 130px;
            height: 130px;
        }
    }

    &__beta {
        margin: 0;
        font-family: 'Gilroy', sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 25px;
        color: var(--text-third-color);
    }

    // the notice block of the activation pages
    &__notice {
        display: flex;
        align-items: flex-start;
        gap: 12px;

        margin-top: 4px;
        padding: 14px 18px;
        border: 1px solid #cdcaf3;
        border-radius: 7px;
        background: #ffffff;
        box-sizing: border-box;

        i {
            flex: 0 0 auto;
            margin-top: 4px;
            font-size: 18px;
            line-height: 1;
            color: var(--general-color);
        }

        p {
            margin: 0;
            font-family: 'Gilroy', sans-serif;
            font-size: 16px;
            font-weight: 500;
            line-height: 25px;
            color: var(--text-third-color);

            b {
                font-weight: 700;
                color: var(--text-color);
            }
        }
    }

    &__text {
        color: var(--text-second-color);
        font-family: 'Gilroy', sans-serif;
        font-size: 24px;
        font-weight: 700;
        line-height: 170%;
        padding: 0 20px 0 0;
        text-transform: none;
    }

    ul {
        list-style: none;

        li {
            position: relative;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 28px;
            color: var(--text-third-color);
            margin: 10px 0;
            padding-left: 25px;

            &::before {
                content: url("@/assets/intlTel/check.svg");
                position: absolute;
                left: 0;
                top: 10px;
                transform: translateY(-50%);
                width: 10px;
                height: 10px;
            }
        }
    }

    @media screen and (max-width: 680px) {
        .activation__block {
            flex-direction: column;
            padding: 15px;
        }

        .activation__text {
            font-size: 14px;
            line-height: 150%;
        }

        .activation__start {
            padding: 0;

            ul li {
                font-size: 12px;
                line-height: 150%;

                &::before {
                    top: 5px;
                }
            }

            .ec_button {
                width: 100%;
            }
        }
    }
}
</style>